// --- Our Modules --------------------------------------------------------------------------------
import "./styles.css";

// --- Types --------------------------------------------------------------------------------------

export type TyMoreAction = {
    label: string;
    icon: string;
    handler: () => void;
    danger?: boolean;
    disabled?: boolean;
};

export type MoreActionsPopupDetails = {
    actions: TyMoreAction[];
};

type Props = {
    onClose: () => void;
    details?: MoreActionsPopupDetails;
};

// --- Logic --------------------------------------------------------------------------------------

export default function MoreActionsPopup({ onClose, details }: Props) {
    const actions = details?.actions ?? [];

    const handleClick = (handler: () => void) => {
        onClose();
        handler();
    };

    return (
        <div className="more-actions-popup">
            {actions.map((action) => (
                <button
                    key={action.label}
                    type="button"
                    className={`more-actions-item${action.danger ? " more-actions-item--danger" : ""}${action.disabled ? " more-actions-item--disabled" : ""}`}
                    onClick={() => !action.disabled && handleClick(action.handler)}
                    disabled={action.disabled}
                >
                    <img src={action.icon} alt="" className="more-actions-item-icon" />
                    <span>{action.label}</span>
                </button>
            ))}
        </div>
    );
}
